/**
 * Whether `/review` renders the Review v0 page instead of today's per-email
 * Inbox.
 *
 * `VITE_ENABLE_REVIEW_V0` decides when it is the literal string "true" or
 * "false". Otherwise it is on only where `VITE_APP_ENV` is `staging`, so QA
 * sees it on staging with no extra variable while a promotion of `main`
 * keeps production on today's Inbox until Step 1 is validated.
 */
export function isReviewV0Enabled(): boolean {
  const explicit = import.meta.env.VITE_ENABLE_REVIEW_V0;
  if (explicit === 'true') return true;
  if (explicit === 'false') return false;
  return import.meta.env.VITE_APP_ENV === 'staging';
}
